const Contact = ({ className = "", color }: { className?: string; color: string }): JSX.Element => (
  <svg
    className={className}
    viewBox="0 0 64 64"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="title"
    aria-describedby="desc"
    role="img"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      fill={color}
      d="M32 0a32 32 0 0 0 0 64c9.9 0 17.826-3.7 20.2-9.424a8.3 8.3 0 0 0-2.082-9.366l-.127-.127a6.072 6.072 0 0 0 .983-2.1c.242-1.687-1.037-2.415-1.826-2.955s-5.514-3.607-6.24-4.085a2.9 2.9 0 0 0-3.918.768c-1.41 1.742-2.152 3.645-8.744-2.947s-4.689-7.334-2.947-8.744a2.9 2.9 0 0 0 .768-3.919c-.479-.725-3.547-5.452-4.086-6.241s-1.268-2.066-2.955-1.824A8.6 8.6 0 0 0 15 21.141c0 5.391 4.25 12 10.055 17.809S37.473 49 42.863 49a8.132 8.132 0 0 0 4.237-1.15l.189.189a4.364 4.364 0 0 1 1.211 5.006C47.113 56.395 41.359 60 32 60a27.969 27.969 0 1 1 26.992-20.528 2 2 0 0 0 3.856 1.065A32.024 32.024 0 0 0 32 0z"
    ></path>
  </svg>
);

export default Contact;
